<template>
  <v-card class="pa-4" max-width="900">
    <v-card-title>
      Editable Users Table
      <v-spacer />
      <v-btn color="primary" @click="addUser">
        <v-icon left>mdi-plus</v-icon> Add New Line
      </v-btn>
    </v-card-title>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-left">Email</th>
            <th class="text-left">Age</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in users" :key="item.id">
            <!-- View Mode -->
            <template v-if="!item.isEditing">
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.age }}</td>
              <td class="text-center">
                <v-btn icon small color="primary" @click="startEdit(index)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small color="error" @click="removeUser(index)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </td>
            </template>

            <!-- Edit Mode -->
            <template v-else>
              <td>
                <v-text-field
                  v-model="item.editBuffer.name"
                  dense
                  hide-details
                  outlined
                  placeholder="Name"
                />
              </td>
              <td>
                <v-text-field
                  v-model="item.editBuffer.email"
                  dense
                  hide-details
                  outlined
                  placeholder="Email"
                />
              </td>
              <td>
                <v-text-field
                  v-model.number="item.editBuffer.age"
                  type="number"
                  dense
                  hide-details
                  outlined
                  placeholder="Age"
                />
              </td>
              <td class="text-center">
                <v-btn icon small color="success" @click="saveEdit(index)">
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
                <v-btn icon small color="grey" @click="cancelEdit(index)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Saved Data Preview -->
    <v-divider class="my-4" />
    <v-card-subtitle>Saved Data (JSON)</v-card-subtitle>
    <v-card-text>
      <pre>{{ savedUsers }}</pre>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      users: [
        { id: 1, name: 'Alice', email: 'alice@example.com', age: 28, isEditing: false },
        { id: 2, name: 'Bob', email: 'bob@example.com', age: 34, isEditing: false }
      ],
      nextId: 3
    };
  },
  computed: {
    savedUsers() {
      return this.users.map(({ id, name, email, age }) => ({ id, name, email, age }));
    }
  },
  methods: {
    addUser() {
      this.users.push({
        id: this.nextId++,
        name: '',
        email: '',
        age: 0,
        isEditing: true,
        editBuffer: { name: '', email: '', age: 0 }
      });
    },
    startEdit(index) {
      const item = this.users[index];
      item.editBuffer = { name: item.name, email: item.email, age: item.age };
      item.isEditing = true;
    },
    saveEdit(index) {
      const item = this.users[index];
      item.name = item.editBuffer.name;
      item.email = item.editBuffer.email;
      item.age = item.editBuffer.age;
      item.isEditing = false;
      delete item.editBuffer;
    },
    cancelEdit(index) {
      const item = this.users[index];
      if (!item.name && !item.email && item.age === 0) {
        this.users.splice(index, 1);
      } else {
        item.isEditing = false;
        delete item.editBuffer;
      }
    },
    removeUser(index) {
      this.users.splice(index, 1);
    }
  }
};
</script>